import { Injectable } from '@angular/core';

import { Adapter } from './adapter';
import { SessionAdapter } from '@/core/adapters/sessionAdapter';

import { User } from '@/core/models/user.model';


@Injectable({
  providedIn: 'root',
})
export class ProfileAdapter implements Adapter<User> {

  public constructor(
    private sessionAdapter: SessionAdapter) {
  }
  /**
   * How to use adapt method
   * .pipe(
   * map((data: any) => {
   *  this.user = this.profileAdapter.adapt(data.body);
   * })
   */
  adapt(item: any): User {
    try {
      if (!item) {
        throw new Error('User profile is missing');
      }
      return new User(
        item.first_name,
        item.last_name,
        item.purpose_of_use,
        item.company,
        item.phone,
        item.email,
        item.creation_date,
        item.last_connected,
        this.sessionAdapter.adapt(item.session),
      );
    } catch (err) {
      console.error('[ProfileAdapter] Failed to adapt user profile:', err);
      // Optional: send to Sentry or remote logger here
      // Rethrow to bubble up
      throw err;
    }
  }
}
